import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { connect } from 'react-redux';
import {
  reduxForm, Field, getFormValues, change,
} from 'redux-form';
import RenderField from '../RenderField';
import {
  isRequired, dateRangeValidate, isAfterNovember2020, isAfterToday,
} from '../../../utils/validator';
import { formatDate } from '../../../utils/func';
import AlertModal from '../ModalStyled/AlertModal';

import {
  ButtonGroup,
  CategoryTitle,
  DownloadModalBody,
  DateFields,
  ModalTitlesContainer,
  ModalTitle,
  ModalSubTitle,
  CategoriesContainer,
  CategoryContainer,
  BoxContainer,
  BoxInfo,
} from './css';
import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../../lib/ui/buttons/SecondaryButton';
import DatePicker from '../../../lib/ui/form_elements/DatePicker';

const BOX_CONTAINER_MAX_HEIGHT = '145px';

const initialValues = {
  filterFromDate: formatDate(new Date((new Date()).getTime() - (60 * 24 * 60 * 60 * 1000))),
  filterToDate: formatDate(new Date()),
};

class DownloadReportModal extends React.Component {
  constructor(props) {
    super(props);
    props.dispatch(change('DownloadReportModal', 'filterAccountNumbers', props.accountNumbers));
  }

  handleDownloadSubmit = (e) => {
    e.preventDefault();
    if (!this.props.valid) return;

    const { formData: { filterFromDate, filterToDate, filterAccountNumbers }, onDownload } = this.props;

    const accountNumbers = filterAccountNumbers && filterAccountNumbers.filter((n) => n !== '');
    if (!accountNumbers || accountNumbers.length === 0) return;

    onDownload({ filterFromDate, filterToDate, filterAccountNumbers: accountNumbers });
  };

  content = () => {
    const { accountNumbers, initialDate, maxDate } = this.props;
    return (
      <DownloadModalBody>
        <form>
          {/* <CategoryTitle>{t('DownloadShipmentReportDateRange')}</CategoryTitle> */}
          <DateFields>
            <Field
              name="filterFromDate"
              type="date"
              component={DatePicker}
              initialDate={initialDate || null}
              maxDate={maxDate || null}
              label={t('From')}
              validate={[isRequired, isAfterNovember2020, isAfterToday, dateRangeValidate]}
            />
            <Field
              name="filterToDate"
              type="date"
              component={DatePicker}
              label={t('To')}
              initialDate={initialDate || null}
              maxDate={maxDate || null}
              validate={[isRequired, isAfterNovember2020, isAfterToday, dateRangeValidate]}
            />
          </DateFields>
          <CategoriesContainer>
            <CategoryContainer>
              <CategoryTitle>{t('BillingAccount')}</CategoryTitle>
              <BoxContainer maxHeight={BOX_CONTAINER_MAX_HEIGHT}>
                <BoxInfo>
                  <Field
                    name="filterAccountNumbers"
                    type="checkboxes"
                    component={RenderField}
                    multiple
                    data={accountNumbers}
                  />
                </BoxInfo>
              </BoxContainer>
            </CategoryContainer>
          </CategoriesContainer>
        </form>
      </DownloadModalBody>
    );
  };

  render() {
    const { onClose, title, description } = this.props;
    const header = () => (
      <ModalTitlesContainer>
        <ModalTitle>{title}</ModalTitle>
        <ModalSubTitle>{description}</ModalSubTitle>
      </ModalTitlesContainer>
    );

    const actions = () => (
      <ButtonGroup>
        <SecondaryButton type="button" onClick={onClose} showArrow={false}>
          {t('Cancel')}
        </SecondaryButton>
        <PrimaryButton className="submit" onClick={(e) => this.handleDownloadSubmit(e)}>
          <span className="icon" />
          {t('Download')}
        </PrimaryButton>
      </ButtonGroup>

    );

    return (
      <AlertModal
        isOpen
        shrinkwrapContent
        onClose={onClose}
        header={header}
        content={this.content}
        actions={actions}
        headerIsVisible
      />
    );
  }
}

DownloadReportModal.propTypes = {
  onClose: PropTypes.func,
  onDownload: PropTypes.func,
  dispatch: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  accountNumbers: PropTypes.arrayOf(PropTypes.string),
  initialDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  valid: PropTypes.bool,
  formData: PropTypes.shape({
    filterFromDate: PropTypes.string,
    filterToDate: PropTypes.string,
    filterAccountNumbers: PropTypes.arrayOf(PropTypes.string),
  }),
};

const mstp = (state) => ({
  formData: getFormValues('DownloadReportModal')(state),
});

DownloadReportModal = reduxForm({
  form: 'DownloadReportModal', // a unique identifier for this form
  initialValues,
})(DownloadReportModal);

export default connect(mstp)(DownloadReportModal);
